import { Tooltip } from '@lib/components'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { showComments } from '@storeOld/reducers/comments'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import type { AppState } from '@/types'
import { clsJoin } from '@/utils'
import cssNode from '../../../../Node.module.scss'
import useNote from '../../../Note/useNote'
import css from './BlockContentViewButton.module.scss'

type Props = {
  nodeId: string
}

const MAX_DISPLAYED_COMMENTS_NUMBER = 999

const BlockContentViewButton: React.FC<Props> = ({ nodeId }) => {
  const dispatch = useDispatch()

  const isEmbed = useSelector<AppState, boolean>(
    ({ artboard }) => artboard.isEmbed
  )

  const noteProps = useNote(nodeId)
  const commentsCount = useSelector<AppState, number>(({ manager }) => {
    return manager.comments.filter((comment) => comment.commentable === nodeId)
      .length
  })

  const onClick = () => {
    // @todo implement later
    // @ts-expect-error
    dispatch(showComments(nodeId))
  }

  const hasComments = commentsCount > 0
  const hasContent = useSelector(
    migrationProjectSelector.getProjectNodeHasContentSelector(nodeId)
  )

  if (isEmbed && !hasComments && !hasContent) {
    return null
  }

  const cn = clsJoin(
    cssNode.actionButton,
    css.container,
    isEmbed && css.disabled,
    (hasComments || hasContent) && css.show,
    hasComments && hasContent && css.wide
  )

  return (
    <Tooltip
      content="Content"
      position="top"
      onClick={!isEmbed ? onClick : () => {}}
    >
      <div className={cn}>
        {hasComments && (
          <div className={css.commentsCount}>
            {Math.min(commentsCount, MAX_DISPLAYED_COMMENTS_NUMBER)}
          </div>
        )}
        {(!hasComments || hasContent) && (
          <div className={css.iconContainer}>{noteProps.icon}</div>
        )}
      </div>
    </Tooltip>
  )
}

export default BlockContentViewButton
